<template lang="pug">
  .container-fluid
    .save
      vm-row(vm-type="flex" vm-w="12")
        vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-w=12)
          vm-button(icon="plus" @click="saveRecord") {{ $t('strings.update') }}
    .permissions
      vm-row(vm-justify="center" vm-w="12" vm-align="center")
        vm-col.top(vm-justify="center", vm-align="center" vm-w=12)
          span {{ $t('notifications.all') }}
            toogle(:flag="has_all_notifications" masterSwitch @enableAll="setActiveFlag" @disableAll="setActiveFlag")
        vm-col(vm-w="6")
          .group
            vm-row.separador(vm-type="flex" vm-w="12")
              vm-col.titles(vm-justify="center", vm-align="center", vm-w=12)
                span {{ $t('strings.to_quote') }}
            vm-row.separador(vm-type="flex" vm-w="12")
              vm-col(vm-justify="center", vm-align="center", vm-w=9)
                span {{ $t('notificationsPermissions.project_created') }}:
              vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-w=3)
                toogle(:flag="notifications.indexOf('project_created') > -1" @permission="addNotifications('project_created')" @delete="deleteNotifications('project_created')")
            vm-row.separador(vm-type="flex" vm-w="12")
              vm-col(vm-justify="center", vm-align="center", vm-w=9)
                span {{ $t('notificationsPermissions.quotation') }}:
              vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-w=3)
                toogle(:flag="notifications.indexOf('quotation') > -1" @permission="addNotifications('quotation')" @delete="deleteNotifications('quotation')")
          .group
            vm-row.separador(vm-type="flex" vm-w="12")
              vm-col.titles(vm-justify="center", vm-align="center", vm-w=12)
                span {{ $t('strings.quoted') }}
            vm-row.separador(vm-type="flex" vm-w="12")
              vm-col(vm-justify="center", vm-align="center", vm-w=9)
                span {{ $t('notificationsPermissions.status') }}:
              vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-w=3)
                toogle(:flag="notifications.indexOf('status') > -1" @permission="addNotifications('status')" @delete="deleteNotifications('status')")
            vm-row.separador(vm-type="flex" vm-w="12")
              vm-col(vm-justify="center", vm-align="center", vm-w=9)
                span {{ $t('notificationsPermissions.quotation_file') }}:
              vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-w=3)
                toogle(:flag="notifications.indexOf('quotation_file') > -1" @permission="addNotifications('quotation_file')" @delete="deleteNotifications('quotation_file')")
          .group
            vm-row.separador(vm-type="flex" vm-w="12")
              vm-col.titles(vm-justify="center", vm-align="center", vm-w=12)
                span {{ $t('strings.in_order') }}
            vm-row.separador(vm-type="flex" vm-w="12")
              vm-col(vm-justify="center", vm-align="center", vm-w=9)
                span {{ $t('notificationsPermissions.add_scope') }}:
              vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-w=3)
                toogle(:flag="notifications.indexOf('add_scope') > -1" @permission="addNotifications('add_scope')" @delete="deleteNotifications('add_scope')")
            vm-row.separador(vm-type="flex" vm-w="12")
              vm-col(vm-justify="center", vm-align="center", vm-w=9)
                span {{ $t('notificationsPermissions.pause_project') }}:
              vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-w=3)
                toogle(:flag="notifications.indexOf('pause_project') > -1" @permission="addNotifications('pause_project')" @delete="deleteNotifications('pause_project')")
            vm-row.separador(vm-type="flex" vm-w="12")
              vm-col(vm-justify="center", vm-align="center", vm-w=9)
                span {{ $t('notificationsPermissions.delivery_date') }}:
              vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-w=3)
                toogle(:flag="notifications.indexOf('delivery_date') > -1" @permission="addNotifications('delivery_date')" @delete="deleteNotifications('delivery_date')")
            vm-row.separador(vm-type="flex" vm-w="12")
              vm-col(vm-justify="center", vm-align="center", vm-w=9)
                span {{ $t('notificationsPermissions.payments') }}:
              vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-w=3)
                toogle(:flag="notifications.indexOf('payments') > -1" @permission="addNotifications('payments')" @delete="deleteNotifications('payments')")
        vm-col(vm-w="6")
          .group
            vm-row.separador(vm-type="flex" vm-w="12")
              vm-col.titles(vm-justify="center", vm-align="center", vm-w=12)
                span {{ $t('strings.shipments') }}
            vm-row.separador(vm-type="flex" vm-w="12")
              vm-col(vm-justify="center", vm-align="center", vm-w=9)
                span {{ $t('notificationsPermissions.add_shipment') }}:
              vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-w=3)
                toogle(:flag="notifications.indexOf('add_shipment') > -1" @permission="addNotifications('add_shipment')" @delete="deleteNotifications('add_shipment')")
            vm-row.separador(vm-type="flex" vm-w="12")
              vm-col(vm-justify="center", vm-align="center", vm-w=9)
                span {{ $t('notificationsPermissions.update_shipment') }}:
              vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-w=3)
                toogle(:flag="notifications.indexOf('update_shipment') > -1" @permission="addNotifications('update_shipment')" @delete="deleteNotifications('update_shipment')")
            vm-row.separador(vm-type="flex" vm-w="12")
              vm-col(vm-justify="center", vm-align="center", vm-w=9)
                span {{ $t('notificationsPermissions.update_claim') }}:
              vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-w=3)
                toogle(:flag="notifications.indexOf('update_claim') > -1" @permission="addNotifications('update_claim')" @delete="deleteNotifications('update_claim')")
          .group
            vm-row.separador(vm-type="flex" vm-w="12")
              vm-col.titles(vm-justify="center", vm-align="center", vm-w=12)
                span {{ $t('strings.revisions') }}
            vm-row.separador(vm-type="flex" vm-w="12")
              vm-col(vm-justify="center", vm-align="center", vm-w=9)
                span {{ $t('notificationsPermissions.revision_approved') }}:
              vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-w=3)
                toogle(:flag="notifications.indexOf('revision_approved') > -1" @permission="addNotifications('revision_approved')" @delete="deleteNotifications('revision_approved')")
            vm-row.separador(vm-type="flex" vm-w="12")
              vm-col(vm-justify="center", vm-align="center", vm-w=9)
                span {{ $t('notificationsPermissions.reply_date') }}:
              vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-w=3)
                toogle(:flag="notifications.indexOf('reply_date') > -1" @permission="addNotifications('reply_date')" @delete="deleteNotifications('reply_date')")
          .group
            vm-row.separador(vm-type="flex" vm-w="12")
              vm-col.titles(vm-justify="center", vm-align="center", vm-w=12)
                span {{ $t('strings.rfis') }}
            vm-row.separador(vm-type="flex" vm-w="12")
              vm-col(vm-justify="center", vm-align="center", vm-w=9)
                span {{ $t('notificationsPermissions.add_rfi') }}:
              vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-w=3)
                toogle(:flag="notifications.indexOf('add_rfi') > -1" @permission="addNotifications('add_rfi')" @delete="deleteNotifications('add_rfi')")
            vm-row.separador(vm-type="flex" vm-w="12")
              vm-col(vm-justify="center", vm-align="center", vm-w=9)
                span {{ $t('notificationsPermissions.update_rfi') }}:
              vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-w=3)
                toogle(:flag="notifications.indexOf('update_rfi') > -1" @permission="addNotifications('update_rfi')" @delete="deleteNotifications('update_rfi')")
</template>
<script>
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Users')

export default {
  name: 'EditNotifications',
  components: {
    toogle: () => import('@/components/aditionals/Toogle2.vue')
  },
  data: () => ({
    active: false
  }),
  async created () {
    await this.getNames(this.$route.params.id)
    this.active = this.has_all_notifications
  },
  methods: {
    ...mapActions([
      'loadNotificationsNames',
      'addNotifications',
      'deleteNotifications',
      'addAllNotificationsNames',
      'updateNotifications'
    ]),
    async getNames (id) {
      await this.loadNotificationsNames(id)
    },
    setActiveFlag () {
      if (!this.has_all_notifications) {
        this.addAllNotificationsNames(true)
      } else {
        this.addAllNotificationsNames(false)
      }
    },
    saveRecord () {
      this.updateNotifications({ notifications: this.notifications, id: this.$route.params.id }).then(() => { this.$router.push({ name: 'users' }) })
    }
  },
  computed: {
    ...mapGetters([
      'notifications',
      'has_all_notifications'
    ])
  }
}
</script>

<style lang="scss" scoped>
.admin {
    height: 25rem;
    text-align: center;
    background: white;
    padding: 20px;
  }
  .img{
    height: 70%;
  }
  .card {
    padding: 20px;
    background: white;
    -webkit-box-shadow: 0px 4px 9px -5px rgba(0,0,0,0.15);
    -moz-box-shadow: 0px 4px 9px -5px rgba(0,0,0,0.15);
    box-shadow: 0px 4px 9px -5px rgba(0,0,0,0.15);
  }
  .separador {
    margin: 15px;
  }
  .group {
    padding: 10px 30px 10px 10px;
    margin: 18px;
    background: white;
    -webkit-box-shadow: 0px 4px 9px -5px rgba(0,0,0,0.15);
    -moz-box-shadow: 0px 4px 9px -5px rgba(0,0,0,0.15);
    box-shadow: 0px 4px 9px -5px rgba(0,0,0,0.15);
  }
  .titles {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 18px;
  }
  .top {
    text-align: center;
    padding: 5px;
    background: white;
    -webkit-box-shadow: 0px 4px 9px -5px rgba(0,0,0,0.15);
    -moz-box-shadow: 0px 4px 9px -5px rgba(0,0,0,0.15);
  }
  .save {
    margin: 20px 10px 20px 0px;
  }
</style>
